import React, { Component } from 'react';
import { withStyles } from 'material-ui/styles';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { Toolbar, Button, Icon, DialogActions, IconButton, MenuItem } from 'material-ui';
import ReactTable from "react-table";
import classNames from 'classnames';
import Formsy from 'formsy-react';
import { TextFieldFormsy, CheckboxFormsy, SelectFormsy } from '@fuse';
import axios from 'axios';
import { withAlert } from 'react-alert';
import Loader from "other-components/loader/loader";
import 'react-select/dist/react-select.css'
import { confirmAlert } from 'react-confirm-alert';
import Select from 'react-select';

class pettyCashReimbursment extends Component {

    constructor(props) {
        super(props);

        this.state = {
            loading: false,
            pettyCashBook: null,
            transactionDate: new Date().getFullYear() + "-" + ("0" + ((new Date().getMonth() + 1).toString())).substr(-2) + "-" + ("0" + (new Date().getDate().toString())).substr(-2),
            reimList: []
        };

        // this.setSelectedJob = this.setSelectedJob.bind(this);

    }

    addReimbursment = (data) => {
        console.log(data.pettyCashAmount);
        console.log(data.reimAmount);
        console.log(data.CurrentAmount);

        var pettyCashAmount = parseInt(data.pettyCashAmount);
        var currentAmount = parseInt(data.CurrentAmount);
        var reimAmount = parseInt(data.reimAmount);

        console.log(pettyCashAmount);
        console.log(currentAmount);
        console.log(reimAmount);

        if (isNaN(pettyCashAmount)) pettyCashAmount = -1;
        if (isNaN(currentAmount)) currentAmount = 0;
        if (isNaN(reimAmount)) reimAmount = 0;

        console.log(pettyCashAmount);
        console.log(currentAmount);
        console.log(reimAmount);

        if (pettyCashAmount >= currentAmount + reimAmount) {
            this.setState({ loading: true });
            //  axios.post('http://localhost:5009/pettyCash/addPettyCashReimbursment',data)
            axios.post(window.accountServer + '/pettyCash/addPettyCashReimbursment', data)
                .then(res => {
                    if (res.data.status) {
                        this.setState({ loading: false });
                        this.props.alert.success(res.data.msg);
                        this.getReimHistory("all");
                        this.setState({ pettyCashBook: null });
                        this.setState({ pettyCashAmount: null });
                        this.setState({ pettyCashBalance: null });
                    }

                    else {
                        this.setState({ loading: false });
                        this.props.alert.error(res.data.msg);
                        this.setState({ pettyCashBook: null });
                        this.setState({ pettyCashAmount: null });
                        this.setState({ pettyCashBalance: null });
                    }
                })
        }
        else {
            this.props.alert.error('Maximum Reimbursement is Rs. ' + (pettyCashAmount - currentAmount));
        }
    }

    getBook = () => {

        this.setState({ loading: true });
        var pettyCashBooks = [];
        // axios.get('http://localhost:5009/pettyCash/getPettyCashBook')
        axios.get(window.accountServer + '/pettyCash/getPettyCashBook')
            .then(response => {

                for (let i = 0; i < response.data.length; i++) {

                    if (response.data[i].IS_ACTIVE == 1) {

                        pettyCashBooks.push({
                            value: response.data[i].ID_LEDGER_ACCOUNT,
                            label: response.data[i].NAME,
                            amount: response.data[i].REIMBURSE_AMOUNT
                        });
                    }
                }
                this.setState({ pettyCashBooks: pettyCashBooks });
                this.setState({ loading: false });
            })
    }

    handlePettyCashBook = (selectedOption) => {

        if (selectedOption) {

            this.setState({ pettyCashAmount: "Loading..." });
            this.setState({ pettyCashBalance: "Loading..." });

            this.setState({ pettyCashBook: selectedOption.value });

            // axios.post('http://localhost:5009/pettyCash/getPettyCashBalance',{'id':selectedOption.value})
            axios.post(window.accountServer + '/pettyCash/getPettyCashBalance', { 'id': selectedOption.value })
                .then(response => {

                    if (response.data.length > 0) {

                        this.setState({ pettyCashAmount: selectedOption.amount });
                        this.setState({ pettyCashBalance: response.data[0].BALANCE });
                    }

                    else {

                        this.setState({ pettyCashAmount: selectedOption.amount });
                        this.setState({ pettyCashBalance: "No Balance" });
                    }

                }).catch(function (error) {
                    console.log("err " + error);
                });

            // this.getReimHistory(selectedOption.value);
        }

        else {

            this.setState({ pettyCashBook: null });
            this.setState({ pettyCashAmount: null });
            this.setState({ pettyCashBalance: null });
        }
    }

    getReimHistory = (id) => {

        axios.post(window.accountServer + '/pettyCash/getReimByBook', { 'id': id })
            .then(response => {
                console.log('sssssssssssssssssssssssss', response.data);
                this.setState({ reimList: response.data });

            }).catch(function (error) {
                console.log("err " + error);
            });
    }


    render() {
        const { classes } = this.props;

        if (this.state.loading) {
            return (

                <Loader />

            );
        }
        else {

            return (

                <React.Fragment>

                    <Toolbar className="flex flex-wrap pt-24 px-12">
                        <h2 className="subtitle-margin subtitle-color w-full sm:w-1/4">
                            Petty Cash Reimbursement
                        </h2>
                    </Toolbar>
                    <Formsy
                        onValidSubmit={this.addReimbursment}
                    >
                        <div className="block">
                            <div className="w-full sm:w-1/2 md:w-1/5 p-8 petty-cash-search-margin inline-block">

                                <TextFieldFormsy
                                    type="date"
                                    name="reimDate"
                                    label="Transaction Date"
                                    value={this.state.transactionDate}
                                />
                            </div>
                            <div className="w-full sm:w-1/2 md:w-1/5 p-8 inline-block">

                                <TextFieldFormsy
                                    type="text"
                                    name="reimRef"
                                    label="Reference No."
                                />
                            </div>
                            
                            <div className="w-full sm:w-1/2 md:w-1/5 p-8 inline-block " style={{position: 'relative', top: '25px', right: '11px' }}>

                                <Select
                                    name="pettyCashBook"
                                    placeholder="Select Petty Cash Book"
                                    value={this.state.pettyCashBook}
                                    onChange={this.handlePettyCashBook}
                                    options={this.state.pettyCashBooks}
                                />

                                <TextFieldFormsy
                                    type="hidden"
                                    name="pettyCashId"
                                    value={this.state.pettyCashBook}
                                    onChange={this.handlePettyCashBook}
                                    options={this.state.pettyCashBooks}
                                />

                                <TextFieldFormsy
                                    type="hidden"
                                    name="pettyCashId"
                                    value={this.state.pettyCashBook}
                                />

                            </div>
                        </div>

                        <div className="block" >

                            
                        </div>

                        <div className="block petty-cash-text-feild-margin petty-cash-search-margin">

                            <div className="w-full sm:w-1/2 md:w-1/5 p-8 inline-block">

                                <TextFieldFormsy
                                    type="text"
                                    name="pettyCashAmount"
                                    label="Petty Cash Amount"
                                    value={this.state.pettyCashAmount}
                                    disabled
                                />

                            </div>

                            <div className="w-full sm:w-1/2 md:w-1/5 p-8 inline-block">

                                <TextFieldFormsy
                                    type="text"
                                    name="CurrentAmount"
                                    label="Current Amount"
                                    value={this.state.pettyCashBalance}
                                    disabled
                                />

                            </div>

                            <div className="w-full sm:w-1/2 md:w-2/5 p-8 inline-block">

                                <TextFieldFormsy
                                    type="text"
                                    name="reimAmount"
                                    label="Reimbursement"
                                    required
                                />

                            </div>

                            <div className="w-full sm:w-1/2 md:w-1/5 p-8 inline-block">
                                <DialogActions className="justify-right ">
                                    <Button
                                        type="submit"
                                        variant="raised"
                                        color="secondary"
                                    >
                                        Issue
                                    </Button>
                                    <Button
                                        type="reset"
                                        variant="raised"
                                        color="primary"
                                        onClick={(ev) => {
                                            this.setState({ pettyCashBook: null });
                                            this.setState({ pettyCashAmount: null });
                                            this.setState({ pettyCashBalance: null });
                                        }}
                                    >
                                        Clear
                                    </Button>
                                    <Button
                                        variant="raised"
                                        color="default"
                                    >
                                        Help
                                    </Button>
                                </DialogActions>
                            </div>

                        </div>



                    </Formsy>

                    <div class="flex h-auto mt-4">

                        <div class="w-full bg-white h-auto">
                            <ReactTable
                                className={classNames(classes.root, "-striped -highlight m-12 p-20  border-2 border-green-darkest")}
                                getTrProps={(state, rowInfo, column) => {
                                    return {
                                        className: "cursor-pointer",
                                    }
                                }}
                                data={this.state.reimList}
                                columns={[
                                    {
                                        Header: "Transaction Date",
                                        accessor: "DATE",
                                        filterable: true,
                                        className: '',
                                        width: 200,
                                        Cell: row => (
                                            row.original.DATE.substr(0, 10)
                                        )
                                    },
                                    {
                                        Header: "Reference No.",
                                        accessor: "DOCUMENT_NO",
                                        filterable: true,
                                        className: '',
                                        Cell: row => (
                                            row.original.DOCUMENT_NO
                                        )
                                    },
                                    {
                                        Header: "Document No.",
                                        accessor: "TANSACTION_TYPE",
                                        filterable: true,
                                        className: "",
                                        Cell: row => (
                                            row.original.TANSACTION_TYPE + ' ' + row.original.REFERENCE_ID
                                        )
                                    },
                                    {
                                        Header: "Petty Cash Book",
                                        accessor: "NAME",
                                        filterable: true,
                                        className: "",
                                    },
                                    {
                                        Header: "Petty Cash Amount",
                                        accessor: "REIMBURSE_AMOUNT",
                                        filterable: true,
                                        className: "justify-start",
                                        Cell: row => (
                                            new Intl.NumberFormat().format(row.original.REIMBURSE_AMOUNT)
                                        )
                                    },
                                    {
                                        Header: "Reimbursement Amount",
                                        accessor: "DR",
                                        filterable: true,
                                        className: "justify-start",
                                        Cell: row => (
                                            new Intl.NumberFormat().format(row.original.DR)
                                        )
                                    }

                                ]}
                                defaultPageSize={10}
                                noDataText="No Reimbursments found"
                            />

                        </div>
                    </div>

                </React.Fragment>
            );
        }
    }

    componentWillMount() {

        this.getBook();
        this.getReimHistory("all");
    }
}

export default withStyles({ withTheme: true })(withRouter(connect()(withAlert(pettyCashReimbursment))));


// WEBPACK FOOTER //
// ./src/main/content/accounting/pettyCash/pettyCashReimbursment.js